import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { FaLinkedin, FaTwitter } from "react-icons/fa";
import { useLanguageData } from '../../hooks/useLanguageData';

function AmbassadorSection() {
  const { t } = useTranslation();
  const [ambassadorData, setAmbassadorData] = useState(null);
  const messageContentRef = useRef(null);
  
  const { 
    data: ambassadorResponse, 
    loading, 
    error 
  } = useLanguageData('/api/v1/embassy/embassy-person');

  useEffect(() => {
    if (ambassadorResponse?.data) {
      setAmbassadorData(ambassadorResponse.data);
    }
  }, [ambassadorResponse]);

  // Fonction simple et efficace pour ajouter target="_blank" à tous les liens
  const addTargetBlankToLinks = (html) => {
    if (!html) return '';
    
    // Créer un élément temporaire
    const div = document.createElement('div');
    div.innerHTML = html;
    
    // Ajouter target="_blank" à tous les liens
    div.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
    
    return div.innerHTML;
  };

  return (
    <section className="section-home-preambule">
      <div className="columns-container">
        <div className="content-left">
          <span className="section-title">{t('ambassador.title')}</span>
          
          {loading ? (
            <div className="ambassador-image-container loading">
              <div className="loading-spinner"></div>
            </div>
          ) : error ? (
            <div className="ambassador-image-container error">
              <div className="error-message">{t('common.error')}</div>
            </div>
          ) : (
            <div className="ambassador-image-container">
              <img
                src={ambassadorData?.picture}
                alt={ambassadorData?.name || t('ambassador.alt')}
              />
            </div>
          )}
          
          <div className="ambassador-info-sidebar">
            {loading ? (
              <div className="loading-placeholder">
                <div className="loading-line" style={{ width: '80%', height: '24px', marginBottom: '10px' }}></div>
                <div className="loading-line" style={{ width: '100%', height: '18px' }}></div>
              </div>
            ) : error ? (
              <div className="error-message-full">
                {t('common.error')}
              </div>
            ) : ambassadorData ? (
              <>
                <div className="ambassador-name" style={{ color: "#000" }}>
                  {ambassadorData.civility} {ambassadorData.name}
                </div>
                <div className="ambassador-title" style={{ fontSize: '17px' }}>
                  {ambassadorData.position}
                </div>
                <div className="social-links">
                  {ambassadorData.socialLinkedin && (
                    <a
                      href={ambassadorData.socialLinkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={t('ambassador.linkedin')}
                    >
                      <FaLinkedin />
                    </a>
                  )}
                  {ambassadorData.socialTwitter && (
                    <a 
                      href={ambassadorData.socialTwitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={t('ambassador.twitter')}
                    >
                      <FaTwitter />
                    </a>
                  )}
                </div>
              </>
            ) : null}
          </div>
        </div>

        <div className="content-right">
          <div className="message-content" style={{
            // maxHeight: '800px',
            // overflowY: 'auto',
            paddingRight: '15px'
          }} ref={messageContentRef}>
            {loading ? (
              <div className="loading-content">
                {[...Array(3)].map((_, index) => (
                  <div key={index} className="loading-paragraph">
                    <div className="loading-line" style={{ width: '100%', height: '16px', marginBottom: '8px' }}></div>
                    <div className="loading-line" style={{ width: '95%', height: '16px', marginBottom: '8px' }}></div>
                    <div className="loading-line" style={{ width: '90%', height: '16px', marginBottom: '20px' }}></div>
                  </div>
                ))}
              </div>
            ) : error ? (
              <div className="error-message-content">
                {t('common.error')}
              </div>
            ) : ambassadorData && ambassadorData.mot_ministry ? (
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: addTargetBlankToLinks(ambassadorData.mot_ministry || '') 
                }} 
              />
            ) : (
              <div className="error-message-content">
                {t('ambassador.messageUnavailable')}
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #1a3c5e;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto;
        }
        
        .loading-placeholder, .loading-content {
          width: 100%;
        }
        
        .loading-line {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }
        
        .loading-paragraph {
          margin-bottom: 20px;
        }
        
        .error-message, .error-message-full, .error-message-content {
          color: #666;
          text-align: center;
          padding: 20px;
          font-style: italic;
        }
        
        .ambassador-image-container.error {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 200px;
          background: #f8f9fa;
          border-radius: 8px;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        
        .social-links a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: #1a3c5e;
          color: white;
          border-radius: 50%;
          margin-right: 10px;
          transition: all 0.3s ease;
        }
        
        .social-links a:hover {
          background: #2c5282;
          transform: translateY(-2px);
        }
        
        .social-links svg {
          font-size: 18px;
        }
        
        
        
        .message-content a {
          color: #1a3c5e;
          text-decoration: underline;
        }
        
        .message-content a:hover {
          color: #2c5282;
        }
        
        .message-content::-webkit-scrollbar {
          width: 8px;
        }
        
        .message-content::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        
        .message-content::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }
      `}</style>
    </section>
  );
}

export default AmbassadorSection;